"use client";

import { useTheme } from "next-themes";
import { MouseEvent, ReactNode } from "react";

const DOCS_URL = "https://docs.moondream.ai";

interface DocsLinkProps {
  children: ReactNode;
  className?: string;
}

export function DocsLink({ children, className }: DocsLinkProps) {
  const { theme, resolvedTheme } = useTheme();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Only append theme param if user has explicitly chosen light/dark (not system)
    if (theme === "light" || theme === "dark") {
      e.preventDefault();
      window.location.href = `${DOCS_URL}?theme=${resolvedTheme}`;
    }
    // Otherwise, let the default navigation happen (to DOCS_URL without param)
  };

  return (
    <a href={DOCS_URL} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
